import React, { FC } from "react";
import { Button, Col, Input, Modal } from "antd";
import { Form } from "antd";
import { Row } from "antd";
import { errorMessage } from "../../../utils/notificationUtils";

type ManuallyRegistrationIdPortalProps = {
  open: boolean;
  title: string;
  handleCancel: () => void;
  handleSave: CallableFunction;
  footer: string;
  isLoading: boolean;
};

const ManuallyRegistrationIdPortal: FC<ManuallyRegistrationIdPortalProps> = (props) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await props?.handleSave(values);
      form.resetFields();
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
    }
  };

  return (
    <>
      <Modal
        open={props?.open}
        title={props?.title}
        onCancel={props?.handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button onClick={props?.handleCancel}>Cancel</Button>
            <Button
              htmlType="submit"
              onClick={handleSubmit}
              loading={props?.isLoading}
              style={{
                background: "#008B8B",
                border: "1px solid #008B8B",
                boxShadow: "0px 2px 8px 0px #00000040",
                borderRadius: "10px",
                padding: "12px 25px",
                textTransform: "uppercase",
                color: "white",
              }}
            >
              {props?.footer}
            </Button>
          </>
        )}
        centered
      >
        <div className="update-id-modal">
          <div className="body">
            <Form
              form={form}
              onFinish={handleSubmit}
              labelAlign="left"
              layout="vertical"
              labelWrap
              style={{ width: "100%" }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={24} lg={24} xl={24}>
                  <Form.Item
                    label={props?.title}
                    name="manualId"
                    style={{ marginTop: "0.7rem" }}
                    rules={[
                      {
                        required: true,
                        message: `Please ${props?.title}`,
                      },
                      {
                        pattern: /^\S+$/,
                        message: "ID must not contain spaces",
                      },
                    ]}
                  >
                    <Input placeholder={props?.title} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ManuallyRegistrationIdPortal;
